module.exports = __webpack_public_path__ + "static/media/grafana.37eb9c86.svg";